var swiper = new Swiper(".video-block-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1200: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    990: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    0: {
      slidesPerView: 1.5,
      spaceBetween: 20
    },
  }
});


document.addEventListener("click", function (e) {

  const btn = e.target.closest(".video-open-btn");
  if (!btn) return;

  const modal = document.getElementById("videoModal");
  const container = document.getElementById("videoContainer");

  const videoId = btn.getAttribute("data-video-id");
  const videoEl = document.getElementById(videoId);

  if (videoEl) {
    container.innerHTML = videoEl.innerHTML;
    modal.classList.add("active");

    const video = container.querySelector("video");
    if (video) {
      video.currentTime = 0;
      video.play();
    }
  }
});

// CLOSE
document.addEventListener("click", function (e) {
  if (
    e.target.closest(".video-close") ||
    e.target.closest(".video-modal-overlay")
  ) {
    const modal = document.getElementById("videoModal");
    const container = document.getElementById("videoContainer");

    modal.classList.remove("active");
    container.innerHTML = "";
  }
});